// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"54":"8ed137b86e2c63838b2c","140":"10967463719cc6fe17e2","496":"3cfbca3f4b2ce5b1c457","920":"8235c43541652984c113"}[chunkId] + ".js";
};